export const ERROR_SCREEN_TEXT = 'Banks failed to load';
export const ERROR_SCREEN_SUBTEXT = 'Please try again or cancel this payment.';
export const ERROR_SCREEN_CTA_TEXT = 'Reload';
